import draggableComponent from "vuedraggable";
import BookItem from "../common/bookItem";
import VisibleSwitchAnsChild from "../visibleswitchans/visible_switch_ans_child";
import { OUT_OPEN_TYPE } from "../common/bookItemDefine";
import { store } from "../../../store";
import { VIEW_TYPE } from "../../view_type";
import SystemData from "../../system_data";
// import VisibleSwitchListChild from "./visible_switch_list_child";
export default class VisibleSwitchList extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.connectNumber = this.el.connectNumber;

        this.sameNumberObjs = [];

        this.add_mouse_event();

        this.target.gotoAndStop(0);
    }

    init() {
        this.linkObjects();
        this.diffVerProcess();
    }

    linkObjects() {
        //同編號物件(不含自己)
        this.itemControl.bookItems.forEach(element => {
            if (element.id != this.id && element.connectNumber == this.connectNumber) {
                this.sameNumberObjs.push(element);
                element.target.visible = false;
            }
        });
    }

    diffVerProcess() {
        if (store.nowView == VIEW_TYPE.WEB || store.nowView == VIEW_TYPE.ANDROID || store.nowView == VIEW_TYPE.IOS) {
            //網頁版若子物件為需隱藏物件，則移出連結陣列，避免被開啟顯示
            for (let i = 0; i < this.sameNumberObjs.length; i++) {
                const element = this.sameNumberObjs[i];
                if (element.outOpenType && (element.outOpenType != OUT_OPEN_TYPE.WEB_LINK && element.outOpenType != OUT_OPEN_TYPE.HTML)) {
                    //若子物件是外開按鈕且類型非網址、Html
                    this.sameNumberObjs.splice(i, 1);
                    i--;
                }
            }
            if (this.sameNumberObjs.length == 0) this.target.visible = false;
        }
        if (SystemData.Instance.getPlatform() == 'darwin') {
            //網頁版若子物件為需隱藏物件，則移出連結陣列，避免被開啟顯示
            for (let i = 0; i < this.sameNumberObjs.length; i++) {
                const element = this.sameNumberObjs[i];
                if (element.outOpenType && (element.path.slice(-3) == 'exe' || element.path.slice(-3) == 'flv')) {
                    //若子物件是外開按鈕且類型exe、flv
                    this.sameNumberObjs.splice(i, 1);
                    i--;
                }
            }
            if (this.sameNumberObjs.length == 0) this.target.visible = false;
        }
    }

    trigger() {
        const self = this;
        if (this.sameNumberObjs.length == 0) {
            this.linkObjects();
        }

        const groups = self.itemControl.getItemsByClassName("grouptrigger", this);

        for (let i = 0; i < groups.length; i++) {
            if (groups[i].pageId == this.pageId && groups[i].connectNumber.indexOf("CH") == -1 && groups[i].target != this.target) {
                groups[i].switchObjectList(false);
            }
        }

        this.switchObjectList();
    }

    /**
     * 
     * @param {boolean} show 
     */
    switchObjectList(show) {
        if (show == undefined) {
            this.sameNumberObjs.forEach(element => {
                element.target.visible = !element.target.visible;
                //只要是下拉選單下的按鈕是VisibleSwitchAnsChild，在被收起選單時都會變初始狀態
                if (element instanceof VisibleSwitchAnsChild && !element.target.visible) {
                    element.isOpen = false;
                    if (element.notFirstFrame == true) {
                        element.target.gotoAndStop(1);
                    } else {
                        element.target.gotoAndStop(0);
                    }
                }
            });
        } else {
            this.sameNumberObjs.forEach(element => {
                element.target.visible = show;
                //只要是下拉選單下的按鈕是VisibleSwitchAnsChild，在被收起選單時都會變初始狀態
                if (element instanceof VisibleSwitchAnsChild && !element.target.visible) {
                    element.isOpen = false;
                    if (element.notFirstFrame == true) {
                        element.target.gotoAndStop(1);
                    } else {
                        element.target.gotoAndStop(0);
                    }
                }
            });
        }

    }

    add_mouse_event() {
        this.target.mouseChildren = false;
        this.target.removeAllEventListeners();
        this.target.addEventListener("click", () => {
            this.trigger();
            this.target.gotoAndStop(this.nowBtnIndex);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
        this.target.addEventListener("mouseover", () => {
            if (this.nowBtnIndex == 1) return;
            this.nowBtnIndex = 1;
            this.target.gotoAndStop(this.nowBtnIndex);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
        this.target.addEventListener("mouseout", () => {
            this.nowBtnIndex = this.isUsed ? 1 : 0;
            this.target.gotoAndStop(this.nowBtnIndex);
            this.itemControl.loader.singleAntialiasing(this.target);
        });
    }
}